export const options = [
  { value: 'never', id: 7, label: 'none_never' },
  { value: 'on_same_day', id: 1, label: 'on_same_day' },
  { value: 'one_day_before', id: 2, label: 'one_day_before' },
  { value: 'two_days_before', id: 3, label: 'two_days_before' },
  { value: 'seven_days_before', id: 4, label: 'seven_days_before' },
  { value: 'fourteen_days_before', id: 5, label: 'fourteen_days_before' },
  { value: 'thirty_days_before', id: 6, label: 'thirty_days_before' },
];
